import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';
import MaskedInput from 'react-maskedinput';

const FormPhoneNumberField = ({ name, label, onChange, value, required, error }) => {
	const _onChange = useCallback(
		(e) => {
			let val = e.target.value;
			if (val) {
				val = val.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', '').replaceAll('_', '');
			}

			onChange(e, { name, value: val });
		},
		[name, onChange]
	);

	return <Form.Field required={required} error={error} label={label} control={MaskedInput} mask='(111) 111-1111' placeholder='(555) 555-5555' name={name} onChange={_onChange} value={value} type='tel' />;
};

FormPhoneNumberField.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.any,
	required: PropTypes.bool,
};

export default FormPhoneNumberField;
